import axios from "axios";
import { toast } from "sonner";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("ptg_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// Gracefully handle an expired/invalid session: clear the stale token and send the
// user to the right login instead of showing a cryptic "Not authenticated" on a stale page.
let _redirecting = false;
const _authUrls = ["/auth/login", "/auth/student/login", "/auth/me", "/auth/student/register", "forgot-password", "reset-password"];
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response?.status;
    const url = err.config?.url || "";
    const onAuthCall = _authUrls.some((u) => url.includes(u));
    if (status === 401 && !onAuthCall && !_redirecting) {
      const path = window.location.pathname;
      if (!path.endsWith("/login")) {
        _redirecting = true;
        localStorage.removeItem("ptg_token");
        toast.error("Your session expired — please sign in again.");
        const to = path.startsWith("/student") ? "/student/login"
          : path.startsWith("/teacher") ? "/teacher/login" : "/admin/login";
        setTimeout(() => window.location.assign(to), 900);
      }
    }
    return Promise.reject(err);
  }
);

// Resolve an image reference (full URL, or storage path from our backend)
export const resolveImg = (src) => {
  if (!src) return "";
  if (src.startsWith("http")) return src;
  if (src.startsWith("/api")) return `${BACKEND_URL}${src}`;
  return `${API}/files/${src}`;
};

export const waLink = (number, text) => {
  const digits = (number || "").replace(/\D/g, "");
  return `https://wa.me/${digits}?text=${encodeURIComponent(text || "")}`;
};

// Shared date formatting — DD-MM-YYYY (Asia/Kolkata) everywhere.
const _IST = "Asia/Kolkata";
export const formatDate = (val) => {
  if (!val) return "";
  const d = (typeof val === "string" && val.length <= 10) ? new Date(val + "T00:00:00") : new Date(val);
  if (isNaN(d.getTime())) return typeof val === "string" ? val : "";
  const parts = new Intl.DateTimeFormat("en-GB", { timeZone: _IST, day: "2-digit", month: "2-digit", year: "numeric" }).formatToParts(d);
  const g = (t) => parts.find((p) => p.type === t)?.value || "";
  return `${g("day")}-${g("month")}-${g("year")}`;
};
export const formatDateTime = (val) => {
  if (!val) return "";
  const d = new Date(val);
  if (isNaN(d.getTime())) return typeof val === "string" ? val : "";
  const parts = new Intl.DateTimeFormat("en-GB", { timeZone: _IST, day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: true }).formatToParts(d);
  const g = (t) => parts.find((p) => p.type === t)?.value || "";
  const ap = (parts.find((p) => p.type === "dayPeriod")?.value || "").toUpperCase();
  return `${g("day")}-${g("month")}-${g("year")}, ${g("hour")}:${g("minute")} ${ap}`;
};
